import TasksModule from '@modules/TasksModule';
import { inboxActions, inboxState } from '../state';

/**
 * The return target of a Close started from the Inbox home view. View keys are
 * UUIDs, so this can never name a card.
 */
export const RETURN_HOME = 'inbox-home';

/**
 * Where selection goes when a closed card was the selected one: the card the
 * CSR was on when they clicked Close, if it still exists, or home when they
 * were on home; else the shared previous selection (or home). `returnViewKey`
 * is a view key so an id re-key between the click and now cannot break it.
 */
export function selectReturnCard(returnViewKey: string | undefined) {
  const isHome = returnViewKey === RETURN_HOME;
  const target =
    returnViewKey && !isHome
      ? TasksModule.getTaskByViewKey(returnViewKey)
      : undefined;
  if (target) {
    inboxActions.setSelectedTaskId(target.id);
    return;
  }
  const previousId = inboxState.previousSelectedTaskId;
  if (!isHome && previousId && TasksModule.getTask(previousId)) {
    inboxActions.restorePrevSelectedTaskId();
    return;
  }
  // home, and no deleted id left as previous
  inboxActions.setSelectedTaskId(undefined);
  const dangling = inboxState.previousSelectedTaskId;
  if (dangling) {
    inboxActions.clearPreviousSelectedTaskId(dangling);
  }
}
